import { useEffect, useState } from 'react';

/**
 * Window drag-and-drop onto the documents list. Kept off the uploads provider so other
 * routes do not become drop targets.
 */
const useDocumentListDrop = (enqueueFiles) => {
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const handleDragOver = (event) => {
      if (event.dataTransfer.types && event.dataTransfer.types.includes('Files')) {
        event.preventDefault();
        setIsDragging(true);
      }
    };

    const handleDragLeave = (event) => {
      if (event.dataTransfer.types && event.dataTransfer.types.includes('Files')) {
        setIsDragging(false);
      }
    };

    const handleDrop = (event) => {
      if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
        event.preventDefault();
        setIsDragging(false);
        const files = Array.from(event.dataTransfer.files || []);
        if (files.length === 0) return;
        enqueueFiles(files);
      }
    };

    window.addEventListener('dragover', handleDragOver);
    window.addEventListener('dragleave', handleDragLeave);
    window.addEventListener('drop', handleDrop);

    return () => {
      window.removeEventListener('dragover', handleDragOver);
      window.removeEventListener('dragleave', handleDragLeave);
      window.removeEventListener('drop', handleDrop);
    };
  }, [enqueueFiles]);

  return isDragging;
};

export default useDocumentListDrop;
